/* Predictive search: fetches the predictive-search section as the user types. */
(function () {
  var wrap = document.querySelector('[data-predictive-search]');
  if (!wrap) return;
  var input = wrap.querySelector('[data-predictive-input]');
  var results = wrap.querySelector('[data-predictive-output]');
  var baseUrl = wrap.getAttribute('data-predictive-url');
  if (!input || !results || !baseUrl) return;

  var timer;
  var controller;

  function close() {
    results.innerHTML = '';
    wrap.classList.remove('is-open');
  }

  function search(term) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url = baseUrl + (baseUrl.indexOf('?') > -1 ? '&' : '?') +
      'q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,page,query' +
      '&section_id=predictive-search';
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-predictive-results]');
        results.innerHTML = fresh ? fresh.outerHTML : '';
        wrap.classList.toggle('is-open', !!fresh);
      })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(timer);
    if (term.length < 2) { close(); return; }
    timer = setTimeout(function () { search(term); }, 250);
  });

  // Close on outside click / Escape
  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) close();
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
